export default __webpack_public_path__ + "static/media/background-left.422e0834.png";